import { render, staticRenderFns } from "./PhotogrammetrySystem.vue?vue&type=template&id=c1bb6d9c"
import script from "./PhotogrammetrySystem.vue?vue&type=script&lang=js"
export * from "./PhotogrammetrySystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports